import React, { Component } from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import { withRouter, Link } from "react-router-dom";
import RuleDesc from '../easyrules/RuleDesc';

const styles = theme => ({
  root: {
  }
})

class Rule451 extends Component {
    render() {
        return (
            <RuleDesc
            id="451"
            t1="W底"
            desc=""
            ruleChange={this.props.ruleChange}
            rules={this.props.rules}
        ></RuleDesc>
          );
    }
  }
  

export default withRouter(withStyles(styles)(Rule451));